import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import { FETCH_CONVERSATION_CONTEXT_SUCCESS, FETCH_CONVERSATION_HISTORY_SUCCESS } from '../../actionTypes';

/** @typedef {import('utils/ReduxUtils').EntitySlice<ConversationContext>} ConversationContextEntity */

const contextAdapter = createEntityAdapter({
  selectId: /** @param {ConversationContext} entity */ entity => entity.id,
});

/**
 * @param {ConversationContextEntity} state
 * @param {import("modules/global/generic.types").Action<import('modules/global/generic.types').PageContent<ConversationContext>>} action
 * @returns {ConversationContextEntity}
 */
const updateAllFromPage = (state, { payload: { content } }) => contextAdapter.updateMany(state, content);

export default createReducer(contextAdapter.getInitialState(), {
  [FETCH_CONVERSATION_CONTEXT_SUCCESS]: updateAllFromPage,
  [FETCH_CONVERSATION_HISTORY_SUCCESS]: updateAllFromPage,
});
